// extracted by mini-css-extract-plugin
export default {"profileImg":"profilePanel_profileImg__Qjre+"};